/**
 * Clothing PDP: compact Apple Pay, hover/click color swap.
 * Sibling clicks fetch the full product page (assigned template + blocks)
 * and swap gallery + buy-box inner HTML only when the title and form exist.
 */
(function () {
  var cache = {};

  function labelBag() {
    var label = window.theme && theme.variantStrings && theme.variantStrings.addToCart;
    if (!label) return;
    document.querySelectorAll('.single-add-to-cart-button--text').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === 'add to cart') el.textContent = label;
    });
    document.querySelectorAll('[data-quick-add-label]').forEach(function (el) {
      var text = (el.getAttribute('data-quick-add-label') || '').trim().toLowerCase();
      if (text === 'add to cart') el.setAttribute('data-quick-add-label', label);
    });
  }

  function appleOk() {
    try { return !!(window.ApplePaySession && ApplePaySession.canMakePayments()); }
    catch (e) { return false; }
  }

  function checkoutUrl() {
    var root = (window.theme && theme.routes && theme.routes.root_url) || '';
    if (!root || root === '/') return '/checkout';
    return root.replace(/\/+$/, '') + '/checkout';
  }

  function pageUrl(url) {
    return String(url || '').split('#')[0];
  }

  function buyApple(form) {
    if (!form) return;
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    var qty = form.querySelector('[name="quantity"]');
    var body = new URLSearchParams();
    body.set('id', id.value);
    body.set('quantity', (qty && qty.value) || '1');
    fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('add');
      window.location.href = checkoutUrl();
    }).catch(function () { form.submit(); });
  }

  function bindAppleBtn(btn, row) {
    if (!btn || btn.dataset.geAppleBound === 'true') return;
    btn.dataset.geAppleBound = 'true';
    var form = (row && row.closest('form')) || btn.closest('form') || document.querySelector('.product-form form');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-sold-out') || btn.getAttribute('aria-disabled') === 'true') return;
      buyApple(form);
    });
  }

  function addAppleBtn(row) {
    if (!row) return;
    var existing = row.querySelector('.ge-apple-pay');
    if (existing) {
      bindAppleBtn(existing, row);
      return;
    }
    if (!appleOk()) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ge-apple-pay';
    btn.setAttribute('aria-label', 'Apple Pay');
    var atc = row.querySelector('.single-add-to-cart-button');
    if (atc) row.insertBefore(btn, atc);
    else row.appendChild(btn);
    bindAppleBtn(btn, row);
  }

  function hideWallets() {
    document.querySelectorAll('.template-product-clothing .product-form').forEach(function (form) {
      form.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart').forEach(function (host) {
        host.style.setProperty('display', 'none', 'important');
        host.setAttribute('hidden', '');
      });
      form.querySelectorAll('.product-form__checkout-row').forEach(function (row) {
        addAppleBtn(row);
        if (!row.querySelector('.ge-apple-pay')) row.classList.add('ge-wallet-hidden');
        else row.classList.remove('ge-wallet-hidden');
      });
    });
  }

  function productDoc(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var detail = doc.querySelector('.thb-product-detail');
    if (!detail) return null;
    if (!detail.querySelector('.product-information .product-title')) return null;
    if (!detail.querySelector('.product-form, form [name="id"]')) return null;
    return doc;
  }

  function prefetch(url) {
    var clean = pageUrl(url);
    if (!clean) return Promise.resolve(null);
    if (cache[clean]) return cache[clean];
    cache[clean] = fetch(clean, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('page');
        return r.text();
      })
      .then(function (html) {
        if (!productDoc(html)) throw new Error('incomplete');
        return html;
      })
      .catch(function () { delete cache[clean]; return null; });
    return cache[clean];
  }

  function parseAttr(el, name) {
    try { return JSON.parse(el.getAttribute(name) || '[]'); }
    catch (e) { return []; }
  }

  function preview(swatch) {
    var images = parseAttr(swatch, 'data-images');
    var sizes = parseAttr(swatch, 'data-sizes');
    var color = swatch.getAttribute('data-color') || '';
    var slider = document.querySelector('.template-product-clothing .product-images');
    if (slider && images.length) {
      var imgs = slider.querySelectorAll('img');
      for (var i = 0; i < imgs.length && i < images.length; i++) {
        imgs[i].src = images[i];
        imgs[i].srcset = images[i];
      }
    }
    var nameEl = document.querySelector('[data-ge-color-name]');
    if (nameEl && color) nameEl.textContent = color;
    document.querySelectorAll('.template-product-clothing .product-form__input--block input[type="radio"]').forEach(function (input) {
      var match = sizes.find(function (s) {
        return String(s.name).toLowerCase() === String(input.value).toLowerCase();
      });
      if (!match) return;
      if (match.available) {
        input.classList.remove('is-disabled');
        input.disabled = false;
        input.dataset.available = 'true';
        input.setAttribute('aria-disabled', 'false');
      } else {
        input.classList.add('is-disabled');
        input.disabled = true;
        input.dataset.available = 'false';
        input.setAttribute('aria-disabled', 'true');
      }
    });
    document.querySelectorAll('.product-color-siblings__swatch').forEach(function (el) {
      el.classList.toggle('is-active', el === swatch);
    });
  }

  function swapInner(currentRoot, incomingRoot, selector) {
    var dest = currentRoot.querySelector(selector);
    var src = incomingRoot.querySelector(selector);
    if (!dest || !src) return false;
    dest.innerHTML = src.innerHTML;
    return true;
  }

  function applyHtml(html, url, push) {
    var doc = productDoc(html);
    var incoming = doc && doc.querySelector('.thb-product-detail');
    var current = document.querySelector('.template-product-clothing .thb-product-detail')
      || document.querySelector('.thb-product-detail');
    if (!incoming || !current) {
      window.location.href = url;
      return;
    }

    var galleryOk = swapInner(current, incoming, '.product-image-container');
    var infoOk = swapInner(current, incoming, '.product-information');
    if (!galleryOk || !infoOk) {
      window.location.href = url;
      return;
    }
    if (incoming.getAttribute('data-handle')) {
      current.setAttribute('data-handle', incoming.getAttribute('data-handle'));
    }

    var freshCrumbs = doc.querySelector('.breadcrumbs');
    if (freshCrumbs) window.__geCrumbsTemplate = freshCrumbs.cloneNode(true);
    neutralizeHero();
    if (push) history.pushState({ geClothingUrl: url }, '', url);
    if (window.geInitClothingGallery) window.geInitClothingGallery();
    labelBag();
    bindSwatches();
    hideWallets();
  }

  function loadColor(url, push) {
    return prefetch(url).then(function (html) { applyHtml(html, url, push); });
  }

  function bindSwatches() {
    var root = document.querySelector('[data-ge-color-siblings]');
    if (!root || root.dataset.geBound === 'true') return;
    root.dataset.geBound = 'true';
    prefetch(root.getAttribute('data-current-url') || window.location.pathname);
    root.querySelectorAll('.product-color-siblings__swatch').forEach(function (swatch) {
      var url = swatch.getAttribute('data-url');
      if (url) prefetch(url);
      swatch.addEventListener('mouseenter', function () { preview(swatch); if (url) prefetch(url); });
      swatch.addEventListener('focus', function () { preview(swatch); if (url) prefetch(url); });
      swatch.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!url || url.split('?')[0] === window.location.pathname) return;
        document.querySelectorAll('.product-color-siblings__swatch').forEach(function (el) {
          el.setAttribute('aria-current', el === swatch ? 'true' : 'false');
          el.classList.toggle('is-active', el === swatch);
        });
        loadColor(url, true);
      });
    });
    root.addEventListener('mouseleave', function () {
      var committed = root.querySelector('.product-color-siblings__swatch[aria-current="true"]');
      if (committed) preview(committed);
    });
  }

  window.addEventListener('popstate', function (event) {
    loadColor((event.state && event.state.geClothingUrl) || window.location.href, false);
  });

  function neutralizeHero() {
    document.querySelectorAll('.template-product-clothing [data-header-hero]').forEach(function (el) {
      el.removeAttribute('data-header-hero');
      el.removeAttribute('data-header-tone');
    });
  }

  function init() {
    labelBag();
    neutralizeHero();
    bindSwatches();
    hideWallets();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  var n = 0;
  var t = setInterval(function () { hideWallets(); if (++n > 40) clearInterval(t); }, 250);
})();
